module.exports = __webpack_public_path__ + "img/lightning.1d9cd754.png";